__turbopack_context__.v({
  "buttonLink": "ncTf9W_buttonLink",
  "buttons": "ncTf9W_buttons",
  "container": "ncTf9W_container",
  "content": "ncTf9W_content",
  "img": "ncTf9W_img",
  "linkArrow": "ncTf9W_linkArrow",
  "title": "ncTf9W_title",
});
